import type { IconSvgObject } from './types';

const TropicalStormTracks01Icon: IconSvgObject = [
  ["path", { d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 2C9.5 2 6 7 5.5 9.5C4.00001 8.50001 3.00001 7.50001 2.00002 6.50001L2 6.5C2 14.5 7 18 9.5 18.5C8.5 20 7.50001 21 6.50001 22L6.5 22C14.5 22 18 17 18.5 14.5C20 15.5 21 16.5 22 17.5C22 9.5 17 6 14.5 5.5C15.5 4 16.5 3 17.5 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TropicalStormTracks01Icon;
